<template>
  <div class="holder">
  <div class="heads">
    <div class="head n2">
      <div class="eye">
        <div class="iris"/>
      </div>
    </div>
    <div class="head n3">
      <div class="eye">
        <div class="iris"/>
      </div>
    </div>
    <div class="head">
      <div class="eye">
        <div class="iris"/>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.holder
{
  position: relative;
  width: 100%;
  height: 100%;
}
.heads
{
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  bottom: 0;
  margin: auto;
}

.eye 
{
  position: absolute;
  overflow: hidden;
  background-color: white;
  top: 20%;
  width: 50%;
  left: 25%;
  padding-top: 50%;
  border-radius: 50%;
  animation-name: blink;
  animation-direction: forward;
  animation-delay: 0;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.n2 .eye
{
  animation-delay: 1.3s;
}
.n3 .eye
{
  animation-delay: 1.7s;
}

@keyframes blink {
  20%, 0% {
    transform: scale(1,1);
  }
  10%
  {
    transform: scale(1,0);
  }
}

.eye::before
{
  position: absolute;
  content: '';
  top: 15%;
  left: 15%;
  width: 70%;
  height: 70%;
  background: linear-gradient(0deg, #EE5B28 0%, #FCAC59 100%);
  border-radius: 50%;
}
.eye::after
{
  position: absolute;
  content: '';
  border-radius: 50%;
  filter: blur(40px);
  background-color: white;
  top: -10%;
  left: -10%;
  width: 50%;
  height: 50%;
}
.iris
{
  position: absolute;
  content: '';
  top: 35%;
  left: 35%;
  width: 30%;
  height: 30%;
  background-color: black;
  border-radius: 50%;
}
.iris::after
{
  position: absolute;
  content: '';
  top: 10%;
  left: 25%;
  width: 50%;
  height: 40%;
  border-radius: 50%;
  border-style: none;
  border-top-width: 5px;
  border-top-color: white;
  border-top-style: solid;
}

.head.n2
{
  transform-origin: 50% 100%;
  rotate: -10deg;
  padding-top: 30%;
  left: 12%;
  width: 30%;
  background-color: #FF4B8A;
}
.head.head.n2::before
{
  background: linear-gradient(0deg, #B90325 30%, #FC4E86 100%);
}
.head.n3
{
  transform-origin: 50% 100%;
  rotate: 10deg;
  padding-top: 30%;
  right: 12%;
  width: 30%;
  background-color: #65D3F3;
}
.head.head.n3::before
{
  background: linear-gradient(0deg, #0872B1 30%, #54BCEC 100%);
}

.head
{
  position: absolute;
  overflow: hidden;
  padding-top: 35%;
  bottom: 0;
  background-color: #E5FE93;
  width: 35%;
  border-top-left-radius: 47%;
  border-top-right-radius: 47%;
  animation-name: breath;
  animation-direction: forward;
  animation-iteration-count: infinite;
  animation-duration: 4s;
}

.head.n2
{
  animation-delay: 1.3s;
}
.head.n3
{
  animation-delay: 2.9s;
}



.head::before
{
  position: absolute;
  content: '';
  border-radius: 50%;
  filter: blur(40px);
  background: linear-gradient(0deg, #81BC3F 30%, #C4FA6B 100%);
  top: 10%;
  bottom: -50%;
  left: 10%;
  right: 10%;
}
.head::after
{
  position: absolute;
  content: '';
  border-radius: 50%;
  filter: blur(40px);
  background-color: white;
  top: -20%;
  left: -20%;
  width: 50%;
  height: 50%;
}

@keyframes breath {
  100%, 0% {
    transform: scale(1,1);
  }
  50%
  {
    transform: scale(0.95,.95);
  }
}
</style>